import Controller from "csi/action/Controller";
import declare from "dojo/_base/declare";

function displayGroupKeys(attributes, name?: string): void {
	if (!name) {
		console.group("Attribute Keys");
	} else {
		console.groupCollapsed(name);
	}
	attributes.forEach((attribute) => {
		if (typeof attribute === "string") {
			console.log(attribute);
		} else {
			const { groupKey, matrixTarget } = attribute;
			let groupName = attribute.name;
			if (groupKey) {
				groupName += ", Group Key:" + groupKey;
			}
			if (groupKey) {
				groupName += ", matrixTarget: " + matrixTarget;
			}
			displayGroupKeys(attribute.keys, groupName );
		}
	});
	console.groupEnd();
}

export = declare(Controller, {
	/**
	 * @override
	 * Output view information
	 */
	postProcessSuccess(): void {
		const { widget } = this;
		const { attributeKeys, customViewContainerUrl, customViewId, defView } = widget;
		const customView = widget.getSelectedCustomView?.();

		console.group("View Information:");
		console.info(`Id: ${defView.m_id}`);
		console.info(`Target Class: ${widget.getViewNodeType()}`);

		if (customViewContainerUrl) {
			console.group(`Custom View: ${customView.name}`);
			console.info(`Custom View Version: ${customView.versionOnNode}`);
			console.info(`Custom View URL: ${customViewId}`);
			console.info(`Custom View Container URL: ${customViewContainerUrl}`);
			console.groupEnd();
		}

		if (attributeKeys?.length) {
			displayGroupKeys(attributeKeys);
		}	

		// for now, output all custom view values to be analyzed
		const values = widget.getModifiedCustomViewValues?.();
		if (values) {
			console.log("Current values: ", values);
		}
		console.groupEnd();
	},
});
